import * as React from 'react';
import { useDispatch } from 'react-redux';

export function useRouteMiss(path : string, missAction? : any) {

    const dispatch = useDispatch();

    React.useEffect(() => {

        return () => {
            if (document.location.pathname.indexOf(path) === -1) {
                if (missAction) {
                    dispatch(missAction);
                }
            }            
        };

    });

    return;
}
